import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row gap-6 lg:gap-10 mt-8" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-center text-lg font-bold mt-5" }
const _hoisted_6 = { class: "max-w-[370px] mx-auto w-full lg:w-1/3 2xl:w-1/4" }
const _hoisted_7 = { class: "flex flex-col gap-6" }
const _hoisted_8 = { class: "text-info-900" }
const _hoisted_9 = { class: "text-info-900" }
const _hoisted_10 = { class: "flex flex-col gap-6" }
const _hoisted_11 = { class: "text-info-900" }
const _hoisted_12 = { class: "text-info-900" }

import { inject, onMounted, ref } from 'vue';
import Container from '../components/layout/Container.vue';
import PageHeading from '../components/layout/PageHeading.vue';
import IconPlus from '../components/icons/IconPlus.vue';
import Button from '../components/base/Button.vue';
import Card from '../components/layout/Card.vue';
import ScheduleAccordion from '../components/schedule/ScheduleAccordion.vue';
import { AppConfigType, ScheduleType } from '../types';
import { useRouter } from 'vue-router';
import useSetPageTitle from '../composables/useSetPageTitle';
import { useGettext } from 'vue3-gettext';
import { useSchedulesStore } from '../stores/useSchedulesStore';
import {useTokensStore} from '../stores/useTokensStore';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Schedules',
  setup(__props) {

const { $gettext } = useGettext();

// Set page title
useSetPageTitle($gettext('Schedules'));

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Get schedules from store
const { schedules, updateSchedules, refreshSchedules } = useSchedulesStore();

// Get current token count
const { isTokenLimitReached } = useTokensStore();

// Router
const router = useRouter();

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

// Account expired
const isAccountExpired = inject<boolean>('isAccountExpired');

// Update the schedules on mount
onMounted(() => {
	// Fetch schedules from the store
	updateSchedules();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Container, null, {
    default: _withCtx(() => [
      _createVNode(PageHeading, {
        heading: _unref($gettext)('Schedules')
      }, null, 8, ["heading"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Button, {
              class: "max-lg:w-full",
              text: _unref($gettext)('Add new schedule'),
              size: "large",
              "icon-position": 'left',
              disabled: _unref(isAccountFree) || _unref(isTokenLimitReached) || _unref(isAccountExpired),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/add-schedule')), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(IconPlus)
              ]),
              _: 1
            }, 8, ["text", "disabled"])
          ]),
          (_unref(schedules).length)
            ? (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col gap-5 mt-5",
                key: _unref(refreshSchedules)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schedules), (schedule) => {
                  return (_openBlock(), _createBlock(ScheduleAccordion, {
                    schedule: schedule,
                    key: schedule.id
                  }, null, 8, ["schedule"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref($gettext)('No schedules to display!')), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(isAccountFree))
            ? (_openBlock(), _createBlock(Card, {
                key: 0,
                "image-url": `${_unref(config).plugin_url}/public/images/articles.png`,
                "image-alt": _unref($gettext)('Upgrade to premium plan'),
                type: "vertical"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref($gettext)('On trial you can generate and publish only one article.')), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref($gettext)(
                                    'Upgrade to paid plan to publish articles more often - few times a day, on different hours.'
                                )), 1),
                    _createVNode(Button, {
                      text: _unref($gettext)('Upgrade'),
                      size: "large",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(router).push('/upgrade')), ["prevent"]))
                    }, null, 8, ["text"])
                  ])
                ]),
                _: 1
              }, 8, ["image-url", "image-alt"]))
            : (_openBlock(), _createBlock(Card, {
                key: 1,
                "image-url": `${_unref(config).plugin_url}/public/images/schedules-paid.png`,
                "image-alt": _unref($gettext)('Buy more articles'),
                type: "vertical"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_unref($gettext)('Run out of articles for the week? We got you covered.')), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref($gettext)(
                                    'Buy additional package of 5, 10, or 15 articles, which will be added to your account permanently.'
                                )), 1),
                    _createVNode(Button, {
                      text: _unref($gettext)('Add more articles'),
                      size: "large",
                      type: "secondary",
                      disabled: _unref(isAccountExpired),
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(router).push('/add-articles')), ["prevent"]))
                    }, null, 8, ["text", "disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["image-url", "image-alt"]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})